module.exports = __webpack_public_path__ + "assets/star.88a5f7c5b3c6c251eb8ce155cfe3629e.svg";